


















































import Component from 'vue-class-component';
import Vue from 'vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import { required } from '@/common/validation/validation';
import { WorkPeriodTemplate } from '@/context/work_period/model/WorkPeriodTemplate';
import { WorkType } from '@/context/work_period/model/WorkType';
import TextField from '@/general/component/TextField.vue';
import { WorkPeriodModel } from '@/context/work_period/model/WorkPeriodModel';

@Component({
  components: {
    DataLoggerAutocomplete,
    FacilityAutocomplete,
    TextInput,
    TextField
  }
})
export default class WorkPeriodTemplateFormTemplate extends Vue {
  @VModel({ type: Object }) model!: WorkPeriodTemplate;
  valid = true;

  get rules(): Record<string, unknown> {
    return {
      facility: [required],
      identifier: [required]
    };
  }

  get workTypes(): string[] {
    return WorkType.getValues();
  }
  copy(index: number) {
    const dayToCopy = this.model.days[index];
    const input = dayToCopy.map((day: WorkPeriodModel) => ({
      hour: day.hour,
      workType: day.workType
    }));
    let keys = Object.keys(this.model.days);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      for (let l = 0; l < this.model.days[key].length; l++) {
        if (l !== index) {
          const hours = this.model.days[key];
          for (let j = 0; j < hours.length; j++) {
            const templateElement = input.find(elem => elem.hour === hours[j].hour);
            if (templateElement) {
              hours[j].workType = templateElement.workType;
            }
          }
        }
      }
    }
  }
}
